module.exports = __webpack_public_path__ + "images/794a174b18798b3ef6675f0d7c6b9b9a.png";